module.exports = fox._r("images/uploading_icon.gif", __webpack_public_path__ + "_/_/_/common/frame/images/uploading_icon.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/uploading_icon.gif
// module id = 99
// module chunks = 2